import { LabelType, Options } from '@angular-slider/ngx-slider';
import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ElementRef,
  Renderer2,
  AfterViewChecked,
  ViewChild,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  OrganizationReportingService,
  ProjectsFacade,
  SharedFacade,
  customDecode,
  customEncode,
  noWhitespaceValidator,
  addFullStop,
  encrypt,
  validateFeatures,
  FeatureValidation,
  isFeatureEnabled,
  showFeatureAlert,
  getRolesAndPermission,
} from '@piqet-angular/data';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { ActionButtonComponent } from 'libs/ui/src/lib/action-button/action-button.component';
import { GridCellDropdownComponent } from 'libs/ui/src/lib/grid-cell-dropdown/grid-cell-dropdown.component';
import { GridNewAddProjectSliderComponent } from 'libs/ui/src/lib/grid-new-add-project-slider/grid-new-add-project-slider.component';
import { cloneDeep } from 'lodash';
import { ProjectsDataGridService } from '../../projects-data-grid.service';
import {
  FeatureCodes,
  mainModuleName,
  rolesModuleName,
  ScopePresetsEnum,
} from 'libs/shared/src/lib/constants';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { TitleCasePipe, ViewportScroller } from '@angular/common';
import { catchError, of, finalize } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { GridCellRendererComponent } from 'libs/ui/src/lib/grid-cell-renderer/grid-cell-renderer.component';
import {
  AccessPermissionService,
  AnalyticsService,
  FileUploadComponent,
  FileUploadResult,
} from '@piqet-angular/shared';
@Component({
  selector: 'piqet-angular-project-details-content',
  templateUrl: './project-details-content.component.html',
  styleUrls: ['./project-details-content.component.scss'],
})
export class ProjectDetailsContentComponent implements OnInit, AfterViewChecked {
  @ViewChild('myFileInput', { static: false }) myFileInput!: ElementRef<HTMLInputElement>;
  userChanges = false;
  showCurrencyList: any;
  scopePresetsEnum = ScopePresetsEnum;
  payloadPackagingLCStages: any = [];
  payloadProductWestModeling: any = [];
  payloadProductLCStages: any = [];
  payloadPackagingLevels: any = [];
  scopePresetId: any;
  checkboxForm!: FormGroup;
  productWestModeling: any;
  packagingLCStages: any;
  fullProductLoss: any;
  productLCStages: any;
  packagingLevels: any;
  selectedShareWith: any;
  allScopePresets: any;
  selectedStatusItem: any;
  isLockChecked: any;
  isPersonChecked = false;
  isShowTeamList = false;
  teamList: any;
  selectedCurrency: any;
  selectedBox: any;
  submitted = false;
  isShowChange = false;
  selectedFiles: any;
  imageUrl: any;
  fileBase64: any;
  statusList: any;
  activatedRouteProjectId: any;
  allProjectDetails: any;
  allProjectForm!: FormGroup;
  scopePreset: any;
  isShowDefalutSettings = false;
  selectedProductDepartmentList: any;
  selectedProductFamilyList: any;
  selectedShareStatus: any;
  selectedProductClassList: any;
  errorMessage: any;
  materialItems: any;
  isImageValid = true;
  errorNotification: any;
  blackImage: any;
  shareItems: any;
  selectedShareList: any;
  disableSubmit = false;
  defalutMaterialProjectList: any;
  isCostTurnedOff: any;
  currencyList: any;
  one = false;
  two = false;
  excelImported = false;
  projectSettingImage: any;
  three = false;
  disableSector = true;
  currencyItem: any;
  selectCountry: any;
  FeatureCodes = FeatureCodes;
  frameworkComponents = {
    actionRenderer: ActionButtonComponent,
    GridNewAddProjectSliderComponent: GridNewAddProjectSliderComponent,
    dropdownRendered: GridCellDropdownComponent,
    gridCellRendererComponent: GridCellRendererComponent,
  };
  @Output() saveNewMyProjectEvent = new EventEmitter<any>();
  headerBtn = 'Add row';
  headerBtnName = 'myNewAddProject';
  blackbox = './assets/icons/SimpleRetailPackage-Black-SVG.svg';
  whitebox = './assets/icons/SimpleRetailPackage-White-SVG.svg';
  blackRetail = './assets/icons/RetailTraded-White-SVG.svg';
  whiteRetail = './assets/icons/RetailTraded-Black-SVG.svg';
  blackFullPackage = './assets/icons/FullPackage-Black-SVG.svg';
  whiteFullPackage = './assets/icons/FullPackage-White-SVG.svg';
  padlock = './assets/icons/padlock.svg';
  untickperson = './assets/icons/Untick_person.png';
  departmentValue: any;
  productFamilyValue: any;
  productClass: any;
  regionItems: any;
  defaultRegionItems: any;
  defaultCountry: any;
  processColumnDef: any;
  applyToAll = false;
  pathName: any;
  showView = false;
  showEdit = false;
  showInternalDataLink = false;
  options: Options = {
    floor: 0,
    ceil: 100,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return value + '%';
        case LabelType.High:
          return value + '%';
        default:
          return value + '%';
      }
    },
  };
  allDepartments: any;
  categoryListByDeptId: any;
  skuDeptId: any;
  subCategoryList: any;
  skuCatgId: any;
  skuSubCatgId: any;
  patchedDept: any;
  patchedCategory: any;
  patchedSubCategory: any;
  sectorList: any = [];
  @ViewChild('lossBasedOnSector', { static: false })
  lossBasedOnSector!: ElementRef<HTMLInputElement>;
  @ViewChildren('lcsCheckboxes') lcsCheckboxes!: QueryList<ElementRef>;
  @ViewChild('fileUploadComponent', { static: false }) fileUploadComponent!: FileUploadComponent;
  showSectorDropdown = false;
  sectorsIdentifierId: any;
  selectedSectorItem: any;
  allCategoryData: any;
  allSubCategoryData: any;
  stopRouting = false;
  selectedRecycledItem: any;
  disableSlider = false;
  checkRemoveImgApi = false;

  isBoundaryJustificationDisabled = false;
  isImpactCategoryDisabled = false;
  isOtherAssumptionsDisabled = false;
  isCheckAllTextarea = false;
  isCheckSelectOrg = false;
  isCheckFullLCA = false;
  hideProjectLock = true;
  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private projectService: ProjectsService,
    public projectFacade: ProjectsFacade,
    private projectsDataGridService: ProjectsDataGridService,
    public sharedFacade: SharedFacade,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    public sharedService: SharedService,
    private router: Router,
    private titleCasePipe: TitleCasePipe,
    private viewportScroller: ViewportScroller,
    private toaster: ToastrService,
    private organizationReportingService: OrganizationReportingService,
    private swalService: SwalService,
    private accessService: AccessPermissionService,
    private analyticsService: AnalyticsService
  ) {
    localStorage.removeItem('scenarioName');
    this.sharedService.scenarioNameFunc('');
    const url = location.href.split('/');
    this.activatedRouteProjectId = Number(
      atob(decodeURIComponent(customDecode(this.route.snapshot.params['id'] || url[6])))
    );
    this.processColumnDef = this.projectsDataGridService.getNewDefaultSettingColumn();
    this.pathName = this.route.snapshot.routeConfig?.path;
  }

  ngOnInit(): void {
    this.checkFeatureAccess();
    this.viewportScroller.scrollToPosition([0, 0]);
    this.showView = this.accessService.hasPermission('view', this.pathName, 'packaging');
    this.showEdit = this.accessService.hasPermission('edit', this.pathName, 'packaging');
    this.showInternalDataLink = getRolesAndPermission(
      rolesModuleName.addInternalData,
      mainModuleName.advancedModule
    )?.isOverview;
    this.initForm();
    this.untickperson = this.isPersonChecked
      ? '/assets/icons/Tick_person.png'
      : './assets/icons/Untick_person.png';
    this.loadData();
  }

  private async loadData(): Promise<void> {
    await this.setFormData();
    this.getCategoryCheckboxes();
  }

  private initForm(): void {
    this.allProjectForm = this.formBuilder.group({
      projectName: [
        '',
        [
          Validators.required,
          noWhitespaceValidator,
          this.noDotValidator,
          Validators.maxLength(100),
        ],
      ],
      projectNameForReport: [
        '',
        [
          Validators.required,
          noWhitespaceValidator,
          this.noDotValidator,
          Validators.maxLength(300),
        ],
      ],
      share: [null, Validators.required],
      team: [null],
      status: [null, Validators.required],
      country: [null],
      productClass: [null],
      productFamily: [null],
      productDepartment: [null],
      defaultCountry: [null, Validators.required],
      description: [''],
      boundryJustification: [''],
      categoryJustification: [''],
      otherLimitations: [''],
      recycleContent: [0],
      currency: [null],
      sectorBasedDropdown: [null],
      recycledCredit: [null],
    });
    if (this.showView && !this.showEdit) {
      this.allProjectForm.disable();
    }
  }

  private checkFeatureAccess(): void {
    this.isBoundaryJustificationDisabled = !isFeatureEnabled(
      FeatureCodes.PROJECT_SYSTEM_BOUNDARY_JUSTIFICATION
    );
    this.isImpactCategoryDisabled = !isFeatureEnabled(
      FeatureCodes.PROJECT_IMPACT_CATEGORY_JUSTIFICATION
    );
    this.isOtherAssumptionsDisabled = !isFeatureEnabled(
      FeatureCodes.PROJECT_OTHER_ASSUMPTIONS_LIMITATIONS
    );
    this.isCheckSelectOrg = !isFeatureEnabled(FeatureCodes.PROJECT_ORG_PACKAGING_FOOTPRINT);
    this.isCheckFullLCA = !isFeatureEnabled(FeatureCodes.PROJECT_FULL_PACKAGE_AND_PRODUCT_LCA);
    this.isCheckAllTextarea =
      this.isBoundaryJustificationDisabled ||
      this.isImpactCategoryDisabled ||
      this.isOtherAssumptionsDisabled;
  }

  noDotValidator(control: any) {
    const value = control.value || '';
    return value.includes('.') ? { dotError: true } : null;
  }
  triggerScroll(): void {
    this.sharedService.triggerScroll();
  }

  async setFormData() {
    this.allProjectDetails = await this.longRunningMethod();
    this.excelImported = this.allProjectDetails.excelImported;
    this.isCostTurnedOff = !this.allProjectDetails.isTurnOffCost;
    this.showCurrencyList = !this.isCostTurnedOff ? false : true;
    this.regionItems = this.allProjectDetails.regionItems;
    this.defaultRegionItems = this.allProjectDetails.defaultRegionItems;
    this.shareItems = this.allProjectDetails.shareItems;
    this.statusList = this.allProjectDetails.projectStatusList;
    this.scopePreset = this.allProjectDetails.packageAccountedProductId;
    this.allScopePresets = this.allProjectDetails.projectScopesAll;
    this.scopePresetId = this.allProjectDetails.packageAccountedProductId;
    this.payloadProductWestModeling = this.allProjectDetails.productWestModeling;
    this.payloadPackagingLCStages = this.allProjectDetails.packagingLCStages;
    this.payloadProductLCStages = this.allProjectDetails.productLCStages;
    this.payloadPackagingLevels = this.allProjectDetails.packagingLevels;
    this.teamList = this.allProjectDetails.projectTeamList;
    this.currencyList = this.allProjectDetails.currencyItems;
    this.isLockChecked = this.allProjectDetails?.isLockProject;
    this.hideProjectLock = this.allProjectDetails?.hideProjectLock;
    this.sectorList = this.allProjectDetails?.productSectorItems;
    this.isPersonChecked = this.allProjectDetails?.shareId == 2 ? true : false;
    this.padlock = this.isLockChecked
      ? './assets/icons/padlock.svg'
      : './assets/icons/padunlock.svg';
    this.allDepartments = this.allProjectDetails?.productDepartmentItems;
    this.allCategoryData = this.allProjectDetails?.productFamilyItems;
    this.categoryListByDeptId = this.allCategoryData.filter((x: any) => x.parentRefID == 0);
    this.allSubCategoryData = this.allProjectDetails?.productClassItems;
    this.subCategoryList = this.allSubCategoryData.filter((x: any) => x.parentRefID == 0);
    this.skuDeptId =
      this.allProjectDetails?.skuDepartmentId > 0 ? this.allProjectDetails?.skuDepartmentId : null;
    this.skuCatgId =
      this.allProjectDetails?.skuCategoryId > 0 ? this.allProjectDetails?.skuCategoryId : null;
    this.skuSubCatgId =
      this.allProjectDetails?.skuSubCategoryId > 0
        ? this.allProjectDetails?.skuSubCategoryId
        : null;

    this.projectSettingImage = this.allProjectDetails?.projectImage;
    const urlParts = this.projectSettingImage?.split('/');
    // Get the last part of the URL, which should be the filename
    if (urlParts) {
      const fileName = urlParts[urlParts?.length - 1];
      this.selectedFiles = fileName ? fileName : null;
    }
    if (this.allProjectDetails.allocationforRecycling != undefined) {
      this.allProjectForm.controls['recycleContent'].setValue(
        this.allProjectDetails?.allocationforRecycling
      );
    }
    this.isShowTeamList = this.allProjectDetails.shareId == 3 ? true : false;
    this.selectedBox = this.scopePresetsEnum.filter((x: any, index: any) => {
      return this.scopePreset == this.scopePresetsEnum[index].id;
    });
    switch (this.scopePreset) {
      case 3:
        this.one = true;
        const buttonOne = this.elementRef.nativeElement.querySelector('#home-tab');
        buttonOne.classList.add('nav-link', 'active');
        const buttonTwoforOne = this.elementRef.nativeElement.querySelector('#profile-tab');
        buttonTwoforOne.classList.add('nav-link');
        const buttonThreeforOne = this.elementRef.nativeElement.querySelector('#contact-tab');
        buttonThreeforOne.classList.add('nav-link');
        break;
      case 1:
        this.two = true;
        const buttonTwo = this.elementRef.nativeElement.querySelector('#profile-tab');
        buttonTwo.classList.add('nav-link', 'active');
        const buttonOneForTwo = this.elementRef.nativeElement.querySelector('#home-tab');
        buttonOneForTwo.classList.add('nav-link');
        const buttonTwoForThree = this.elementRef.nativeElement.querySelector('#contact-tab');
        buttonTwoForThree.classList.add('nav-link');
        break;
      case 2:
        this.three = true;
        const buttonElement = this.elementRef.nativeElement.querySelector('#profile-tab');
        buttonElement.classList.add('nav-link');
        const buttonElementforThree = this.elementRef.nativeElement.querySelector('#contact-tab');
        buttonElementforThree.classList.add('nav-link', 'active');
        const buttonThreeForOne = this.elementRef.nativeElement.querySelector('#home-tab');
        buttonThreeForOne.classList.add('nav-link');
        break;
    }
    this.defalutMaterialProjectList = this.allProjectDetails.specificWasteMaterialItems.map(
      (item: any) => {
        return {
          ...item,
          index: item.id,
        };
      }
    );
    this.projectFacade.newMyProjectActionSuccess(this.defalutMaterialProjectList);
    await this.shareStatus();
    await this.selectedStatus();
    await this.getSelectedRecycledItem();
    await this.setShareValue();
    await this.setCurrency();
    await this.setDefaultCountry();
    await this.getDept();
    await this.getSector();
    if (!this.allProjectDetails.countryIds?.length) {
      this.defaultRegionItems = this.regionItems;
    }
    this.projectFacade.storeProjectNameForBreadcrumb(this.allProjectDetails.projectName);
    this.allProjectForm.patchValue({
      projectName: this.allProjectDetails.projectName,
      projectNameForReport: this.allProjectDetails.shortProjectName,
      country: this.allProjectDetails.countryIds,
      description: this.allProjectDetails.description,
      status: this.selectedStatusItem,
      boundryJustification: this.allProjectDetails?.systemBoundaryJustification,
      categoryJustification: this.allProjectDetails.impectCategoryJustification,
      otherLimitations: this.allProjectDetails.otherAssumptionsOrLimitation,
      share: this.selectedShareStatus,
      team: this.selectedShareWith,
      currency: this.currencyItem,
      defaultCountry: this.defaultCountry,
      sectorBasedDropdown: this.selectedSectorItem,
      recycledCredit: this.selectedRecycledItem,
    });
    this.disableSlider =
      this.selectedRecycledItem?.id == 1 || this.selectedRecycledItem?.id == 2 ? true : false;
  }

  onFileSelected(result: FileUploadResult): void {
    if (result.isValid) {
      this.selectedFiles = result.fileName;
      this.imageUrl = result.fileUrl;
      this.fileBase64 = result.fileBase64;
      this.isShowChange = true;
      this.isImageValid = true;
      this.checkRemoveImgApi = true;
    } else {
      this.isImageValid = false;
      this.resetFileState();
    }
  }

  onFileRemoved(): void {
    this.resetFileState();
  }

  private resetFileState(): void {
    this.selectedFiles = null;
    this.imageUrl = null;
    this.fileBase64 = null;
    this.isShowChange = false;
    this.projectSettingImage = null;
    this.checkRemoveImgApi = false;
    this.isImageValid = true;
  }

  async longRunningMethod() {
    const response = await this.projectService.getMyAllProjectModalDataForProjectDetails(
      this.activatedRouteProjectId
    );
    return response.data;
  }

  ngAfterViewChecked() {
    if (!this.userChanges) {
      this.setCategoryCheckboxes(this.allProjectDetails?.packagingLCStages);
      this.setCategoryCheckboxes(this.allProjectDetails?.packagingLevels);
      this.setCategoryCheckboxes(this.allProjectDetails?.productLCStages);
      this.setCategoryCheckboxes(this.allProjectDetails?.productWestModeling);
    }
  }

  async getSector() {
    await this.allProjectDetails?.productSectorItems.map((item: any) => {
      if (item.id == this.allProjectDetails.sectorsIdentifierId) {
        return (this.selectedSectorItem = item);
      }
    });
  }

  costTurnOff(event: any) {
    if (event.target.checked && !this.allProjectDetails.currencyId) {
      // FOR setting USD as default currency if none is selected
      this.allProjectForm
        ?.get('currency')
        ?.setValue(this.allProjectDetails.find((x: any) => x.id == 1));
    }
    this.showCurrencyList = event.target.checked ? true : false;
  }

  selectedSector(event: any) {
    if (!event?.id) return;
    this.sectorsIdentifierId = event?.id;
  }

  onNext(step: string) {
    if (step == 'step7') {
      this.sharedService.accessSideBarData('isGuidedTour');
    } else if (step == 'step13') {
      const sId: any = localStorage.getItem('sId');
      const encodedParams = `{ "id": ${sId} }`;
      this.router.navigate(
        [
          `projects/projects-setting/${customEncode(
            btoa(this.allProjectDetails.projectId)
          )}/scenario-configuration`,
        ],
        { queryParams: { param: encrypt(encodedParams) } }
      );
    }
  }

  onPrev(step: string) {
    if (step == 'step12') {
      this.sharedService.accessSideBarData('isGuidedTour');
    }
  }

  async shareStatus() {
    await this.allProjectDetails?.shareItems.map((item: any) => {
      if (item.id == this.allProjectDetails.shareId) {
        return (this.selectedShareStatus = item);
      }
    });
  }

  async selectedStatus() {
    await this.allProjectDetails?.projectStatusList.map((item: any) => {
      if (item.id == this.allProjectDetails.statusId) {
        return (this.selectedStatusItem = item);
      }
    });
  }

  async getSelectedRecycledItem() {
    await this.allProjectDetails.recycledCreditsList.map((item: any) => {
      if (item.id == this.allProjectDetails.recycledCreditId)
        return (this.selectedRecycledItem = item);
    });
  }

  async getDept() {
    await this.allDepartments?.map((item: any) => {
      if (item.idLong == this.allProjectDetails?.skuDepartmentId) {
        this.patchedDept = item;
        this.allProjectForm.patchValue({ productDepartment: this.patchedDept });
        return;
      }
    });
    this.getSKUCategory();
  }

  async getCategory() {
    await this.categoryListByDeptId?.map((item: any) => {
      if (item.idLong == this.allProjectDetails?.skuCategoryId) {
        this.patchedCategory = item;
        this.allProjectForm.patchValue({ productFamily: this.patchedCategory });
        return;
      }
    });
    this.getSKUSubCategory();
  }

  async getSubCategory() {
    await this.subCategoryList?.map((item: any) => {
      if (item.idLong == this.allProjectDetails?.skuSubCategoryId) {
        this.patchedSubCategory = item;
        this.allProjectForm.patchValue({ productClass: this.patchedSubCategory });
        return;
      }
    });
  }

  checkValidation(defalutMaterialProjectList: any): void {
    const isValidate =
      defalutMaterialProjectList.find((x: any) => !x.hasOwnProperty('materialId')) ||
      !defalutMaterialProjectList.find((x: any) => x.materialId) ||
      defalutMaterialProjectList.some((x: any) => {
        if (x.materialId == null) {
          return true;
        } else {
          return false;
        }
      });
    if (isValidate) {
      this.errorNotification =
        'Please fill all the mandatory information to proceed further in the process.';
      this.disableSubmit = true;
    } else {
      const res: any[] = [];
      defalutMaterialProjectList.map((item: any) => {
        if (!this.errorNotification) {
          const existItem = res.find(
            x => x.materialId == item.materialId && x.amount == item.amount
          );
          if (existItem) {
            this.errorNotification =
              'Material is already exist, please select other material to proceed further.';
            this.disableSubmit = true;
          } else {
            res.push(item);
            this.errorNotification = '';
            this.disableSubmit = false;
          }
        }
      });
    }
    if (defalutMaterialProjectList?.length === 0) {
      this.errorNotification = '';
      this.disableSubmit = false;
    }

    this.processColumnDef = cloneDeep(this.processColumnDef);
    this.processColumnDef[this.processColumnDef.length - 1].cellRendererParams['disableSubmit'] =
      this.disableSubmit;
    this.processColumnDef[0].cellRendererParams['defalutMaterialProjectList'] =
      this.allProjectDetails.materialItems;
    this.processColumnDef[1].cellRendererParams['recycledCreditsList'] =
      this.allProjectDetails.recycledCreditsList;
  }

  onBlur(value: any) {
    this.allProjectForm.controls['projectNameForReport'].setValue(value);
  }

  inlineDataEditEvent(record: any) {
    if (record[2] === 'myNewAddProject') {
      this.projectFacade.newMyProjectAction(record[1], 'edit', record[3]);
    }
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  nextPage(defalutMaterialProjectList: any) {
    if (this.showEdit) {
      this.onSave(defalutMaterialProjectList);
    }
    if (!this.stopRouting) {
      const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
      this.router.navigate([
        `projects/projects-setting/${customEncode(btoa(encodedValue))}/scenario-list`,
      ]);
      if (!this.showEdit) {
        setTimeout(() => {
          if (!this.showEdit) {
            this.sharedService.accessSideBarData(() => {});
          }
        });
      }
    }
  }

  commonInputSearchForCountry(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  showDeafultSettings() {
    this.isShowDefalutSettings = !this.isShowDefalutSettings;
    this.projectFacade.defalutMaterialProjectList$.subscribe((data: any) => {
      this.checkValidation(data);
    });
  }

  lock(event: any) {
    this.isLockChecked = event.target.checked;
    this.padlock = this.isLockChecked
      ? './assets/icons/padlock.svg'
      : './assets/icons/padunlock.svg';
    this.projectService
      .updateProjectDisableStatus(this.allProjectDetails.projectId, this.isLockChecked)
      .subscribe((data: any) => {
        data.messageType ? this.toaster.error(data.message) : this.toaster.success(data.message);
      });
  }

  person(event: any) {
    this.isPersonChecked = event.target.checked;
    this.untickperson = this.isPersonChecked
      ? '/assets/icons/Tick_person.png'
      : './assets/icons/Untick_person.png';
  }

  refreshSKU() {
    this.getAllDepartments();
  }

  onClick(string: any, eve: any) {
    // For click event on Scope boxes
    this.userChanges = true;
    if (string == 'one') {
      this.one = true;
      this.two = false;
      this.three = false;
      this.scopePresetId = 3;
      this.blackImage = true;
      this.disableSector = false;
      this.blackbox = './assets/icons/SimpleRetailPackage-White-SVG.svg';
      this.blackRetail = './assets/icons/RetailTraded-White-SVG.svg';
      this.blackFullPackage = './assets/icons/FullPackage-Black-SVG.svg';
      const buttonElement = this.elementRef.nativeElement.querySelector('#home-tab');
      buttonElement.classList.add('nav-link', 'active');
      const buttonElementTwo = this.elementRef.nativeElement.querySelector('#profile-tab');
      this.renderer.removeClass(buttonElementTwo, 'active');
      const buttonElementThree = this.elementRef.nativeElement.querySelector('#contact-tab');
      this.renderer.removeClass(buttonElementThree, 'active');
    } else if (string == 'two') {
      this.one = false;
      this.two = true;
      this.three = false;
      this.scopePresetId = 1;
      this.blackImage = false;
      this.disableSector = false;
      this.blackbox = './assets/icons/SimpleRetailPackage-Black-SVG.svg';
      this.blackRetail = './assets/icons/RetailTraded-Black-SVG.svg';
      this.blackFullPackage = './assets/icons/FullPackage-Black-SVG.svg';
      const buttonElementThree = this.elementRef.nativeElement.querySelector('#contact-tab');
      this.renderer.removeClass(buttonElementThree, 'active');
    } else if (string == 'three') {
      this.one = false;
      this.two = false;
      this.three = true;
      this.disableSector = true;
      this.scopePresetId = 2;
      this.blackImage = false;
      this.blackbox = './assets/icons/SimpleRetailPackage-Black-SVG.svg';
      this.blackRetail = './assets/icons/RetailTraded-White-SVG.svg';
      this.blackFullPackage = './assets/icons/FullPackage-White-SVG.svg';
      const buttonElementThree = this.elementRef.nativeElement.querySelector('#contact-tab');
      buttonElementThree.classList.add('nav-link', 'active');
    }
    this.projectService
      .getProjectScopeByIdPresets(this.scopePresetId, this.activatedRouteProjectId)
      .subscribe((res: any) => {
        this.resetCheckboxes();
        this.setCategoryCheckboxes(res.data.packagingLCStages, 'isClickedUpon');
        this.setCategoryCheckboxes(res.data.packagingLevels, 'isClickedUpon');
        this.setCategoryCheckboxes(res.data.productLCStages, 'isClickedUpon');
        this.setCategoryCheckboxes(res.data.productWestModeling, 'isClickedUpon');
        this.payloadPackagingLCStages = res.data.packagingLCStages;
        this.payloadProductLCStages = res.data.productLCStages;
        this.payloadPackagingLevels = res.data.packagingLevels;
        this.payloadProductWestModeling = res.data.productWestModeling;
      });
  }

  getCategoryCheckboxes() {
    this.packagingLCStages = this.allScopePresets.filter((x: any) => {
      return x.projectScopeTypeId == 1;
    });
    this.packagingLevels = this.allScopePresets.filter((x: any) => {
      return x.projectScopeTypeId == 2;
    });
    this.productLCStages = this.allScopePresets.filter((x: any) => {
      return x.projectScopeTypeId == 3 && x.scopeId !== 5 && x.scopeId !== 6;
    });
    this.productWestModeling = this.allScopePresets.filter((x: any) => {
      return x.projectScopeTypeId == 4;
    });
    this.fullProductLoss = this.allScopePresets.filter((x: any) => {
      return x.projectScopeTypeId == 3 && (x.scopeId == 5 || x.scopeId == 6);
    });
  }

  setCategoryCheckboxes(data: any, isManuallyClicked?: string) {
    data?.forEach((x: any) => {
      const id = x.scopeId + '_' + x.projectScopeTypeId;
      const checks = document.getElementById(id) as HTMLInputElement;
      checks.checked = true;
    });
    const isSectorChecked = this.lossBasedOnSector?.nativeElement?.checked;
    if (isSectorChecked) {
      this.showSectorDropdown = true;
      this.disableSector = false;
    } else if (!isSectorChecked && isManuallyClicked) {
      this.showSectorDropdown = false;
      this.allProjectForm.controls['sectorBasedDropdown'].setValue(null);
    }
    // Added redundant conditional check to ensure view has been initialized properly
    if (this.three)
      this.disableSector = !(
        !this.lcsCheckboxes?.toArray()[0]?.nativeElement?.checked && this.three
      );
  }

  resetCheckboxes() {
    this.allProjectDetails.projectScopesAll.forEach((x: any) => {
      const id = x.scopeId + '_' + x.projectScopeTypeId;
      const checks = document.getElementById(id) as HTMLInputElement;
      checks.checked = false;
    });
  }

  fileChangeEvent(event: any) {
    const file = event.target.files?.[0];

    // If no file selected, return early
    if (!file) {
      return;
    }

    // Check if file type is valid
    const validTypes = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif'];
    const mimeType = file.type;

    if (!validTypes.includes(mimeType)) {
      // Invalid file type
      this.isImageValid = false;

      // Clear the file input
      event.target.value = '';

      // Reset all file-related properties
      this.selectedFiles = '';
      this.isShowChange = false;
      this.imageUrl = '';
      this.fileBase64 = '';
      this.checkRemoveImgApi = false;

      return;
    }

    // Valid file - process it
    this.isImageValid = true;
    this.selectedFiles = file.name;
    this.isShowChange = true;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.imageUrl = reader.result;
      this.checkRemoveImgApi = true;
      this.fileBase64 = this.imageUrl.split(',')[1];
    };
    reader.readAsDataURL(file);
  }

  removeImage() {
    this.isShowChange = false;
    this.selectedFiles = null;
    this.imageUrl = null;
    this.isImageValid = true;
    this.myFileInput.nativeElement.value = '';
    this.fileBase64 = null;
    this.projectSettingImage = null;
    this.checkRemoveImgApi = false;
    this.toaster.success('Image has been deleted');
  }

  removeProjectImage(): void {
    this.projectService.removeProjectImage(this.activatedRouteProjectId).subscribe((res: any) => {
      if (res.messageType) {
        this.toaster.error(res.message);
      } else {
        this.toaster.success(res.message);
        // Reset the file upload component
        if (this.fileUploadComponent) {
          this.fileUploadComponent.reset();
        }
        this.resetFileState();
        this.resetFileState();
        this.longRunningMethod();
      }
    });
  }

  deleteConfirmation(data?: any): void {
    this.swalService
      .confirm(
        'Are you sure?',
        'Do you really want to delete this image? This process cannot be undone.'
      )
      .then(confirmed => {
        if (confirmed) {
          if (this.checkRemoveImgApi) {
            this.fileUploadComponent.reset();
            this.resetFileState();
            this.toaster.success('Image has been removed');
          } else {
            this.removeProjectImage();
          }
        }
      });
  }

  onChangeForCheckBox(eve: any, item: any) {
    this.userChanges = true;
    const scopeName = item.scopeName?.toLowerCase();
    const isChecked = eve.target.checked;

    if (scopeName === 'product loss (based on sector average)') {
      this.showSectorDropdown = isChecked;
    } else if (scopeName === 'product loss (based on product project)') {
      this.disableSector = isChecked;
      if (isChecked) {
        this.showSectorDropdown = false;
        this.allProjectForm.controls['sectorBasedDropdown'].setValue(null);
        if (this.lossBasedOnSector?.nativeElement) {
          this.lossBasedOnSector.nativeElement.checked = false;
        }
      }
    }

    const checkBoxes = this.allProjectDetails.projectScopesAll.map((x: any) => {
      const id = `${x.scopeId}_${x.projectScopeTypeId}`;
      return document.getElementById(id) as HTMLInputElement;
    });

    this.payloadPackagingLCStages = [];
    this.payloadPackagingLevels = [];
    this.payloadProductLCStages = [];
    this.payloadProductWestModeling = [];

    checkBoxes
      .filter((box: any) => box.checked)
      .forEach((data: any) => {
        const [scopeId, projectScopeTypeId] = data.id.split('_').map(Number);
        const payload = { scopeId, projectScopeTypeId };

        switch (projectScopeTypeId) {
          case 1:
            this.payloadPackagingLCStages.push(payload);
            break;
          case 2:
            this.payloadPackagingLevels.push(payload);
            break;
          case 3:
            this.payloadProductLCStages.push(payload);
            break;
          case 4:
            this.payloadProductWestModeling.push(payload);
            break;
        }
      });
  }

  selectCurrency(event: any) {
    if (event.id) {
      this.selectedCurrency = event?.id;
    }
  }

  async setCurrency() {
    await this.currencyList.map((data: any) => {
      if (data.id == this.allProjectDetails.currencyId) {
        return (this.currencyItem = data);
      }
    });
  }

  async setDefaultCountry() {
    await this.defaultRegionItems.map((data: any) => {
      if (data.id == this.allProjectDetails.countryId) {
        return (this.defaultCountry = data);
      }
    });
  }

  applyToAllSlider(defalutMaterialProjectList: any, isApply: boolean, recycledCredit?: any) {
    if (isApply) {
      defalutMaterialProjectList = defalutMaterialProjectList.map((x: any) => ({
        ...x,
        recycledCreditId: recycledCredit.id,
        range: this.allProjectForm.controls['recycleContent'].value,
      }));
      this.projectFacade.newMyProjectAction(defalutMaterialProjectList, 'edit');
    }
  }

  updateRange(event: any, defalutMaterialProjectList: any) {
    this.applyToAll = false;
    if (!event) return;
    if (event.name == 'PEF method') {
      this.disableSlider = true;
      this.allProjectForm.patchValue({ recycleContent: 20 });
    } else if (event.name == 'PIQET default') {
      this.disableSlider = true;
      this.allProjectForm.patchValue({ recycleContent: 50 });
    } else {
      this.disableSlider = false;
    }
    defalutMaterialProjectList = defalutMaterialProjectList.map((x: any) => ({
      ...x,
      recycledCreditId: this.allProjectForm.controls['recycledCredit'].value?.id,
      range: this.allProjectForm.controls['recycleContent'].value,
    }));
    this.projectFacade.newMyProjectAction(defalutMaterialProjectList, 'edit');
  }

  onClear(defalutMaterialProjectList: any) {
    this.disableSlider = false;
    defalutMaterialProjectList = defalutMaterialProjectList.map((x: any) => ({
      ...x,
      recycledCreditId: 3,
      range: this.allProjectForm.controls['recycleContent'].value,
    }));
    this.projectFacade.newMyProjectAction(defalutMaterialProjectList, 'edit');
  }

  changeRuralValue(data: any) {
    this.applyToAll = false;
  }

  async setShareValue() {
    await this.allProjectDetails?.projectTeamList.map((data: any) => {
      if (data.id == this.allProjectDetails?.teamId) {
        return (this.selectedShareWith = data);
      }
    });
  }

  selectTeam(data: any) {
    this.isShowTeamList = data.name == 'One of my team' ? true : false;
    if (this.isShowTeamList) {
      this.allProjectForm.controls['team'].setValidators([Validators.required]);
    } else {
      this.allProjectForm.controls['team'].clearValidators();
    }
    this.allProjectForm.controls['team'].updateValueAndValidity();
  }

  selectRegion(event: any) {
    const selected = Array.isArray(event) ? event : event ? [event] : [];
    this.analyticsService.trackEvent('region_selected', {
      region_count: selected.length,
      // Only send a specific region id/name when a single region is selected
      // (keeps the param low-cardinality).
      region_id: selected.length === 1 ? selected[0]?.id : undefined,
      region_name: selected.length === 1 ? selected[0]?.name : undefined,
    });
    this.regionItems =
      event.length == 0
        ? this.allProjectDetails.regionItems
        : this.allProjectDetails.defaultRegionItems;
    this.regionItems = this.regionItems;
  }

  defalutCountry(selectCountry: any) {
    if (this.allProjectForm.controls['defaultCountry']?.value?.id) {
      const data = selectCountry.find((data: any) => {
        if (data.id == this.allProjectForm.controls['defaultCountry']?.value.id) {
          return true;
        }
      });
      if (!data) {
        this.allProjectForm.controls['defaultCountry'].setValue(null);
      }
    }
    if (Array.isArray(selectCountry)) {
      this.selectCountry = selectCountry?.length ? selectCountry : this.regionItems;
    }
  }

  addUpdatePackagingProject(data: any) {
    this.projectService
      .addEditMyAllProjectData(data)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.sharedService.accessSideBarData(() => {});
        })
      )
      .subscribe(res => {
        if (res.messageType) {
          this.toaster.error(res.message);
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
            this.router.navigate([
              `projects/projects-setting/${customEncode(btoa(encodedValue))}/setting`,
            ]);
          });
        } else {
          this.toaster.success(res.message);
          this.projectFacade.storeProjectNameForBreadcrumb(data.projectName);
          this.longRunningMethod();
        }
      });
  }

  private validateFeatures(payload: any): string[] {
    const validations: FeatureValidation[] = [
      {
        condition: payload.packageAccountedProductId === 3,
        featureCode: FeatureCodes.PROJECT_SIMPLE_SCOPE_PRESET,
        featureName: 'Simple Retail Package Scope',
      },
      {
        condition: payload.packageAccountedProductId === 1,
        featureCode: FeatureCodes.PROJECT_RETAIL_SCOPE_PRESET,
        featureName: 'Retail Package Scope',
      },
      {
        condition: payload.packageAccountedProductId === 2,
        featureCode: FeatureCodes.PROJECT_FULL_PACKAGE_AND_PRODUCT_LCA,
        featureName: 'Full Package and Product LCA',
      },
      {
        condition: payload.sKUDepartmentId || payload.sKUCategoryId || payload.sKUSubCategoryId,
        featureCode: FeatureCodes.PROJECT_ORG_PACKAGING_FOOTPRINT,
        featureName: 'Organization Internal Data Categories',
      },
      {
        condition: !!payload.systemBoundaryJustification,
        featureCode: FeatureCodes.PROJECT_SYSTEM_BOUNDARY_JUSTIFICATION,
        featureName: 'System Boundary Justification',
      },
      {
        condition: !!payload.ImpectCategoryJustification,
        featureCode: FeatureCodes.PROJECT_IMPACT_CATEGORY_JUSTIFICATION,
        featureName: 'Impact Category Justification',
      },
      {
        condition: !!payload.otherAssumptionsOrLimitation,
        featureCode: FeatureCodes.PROJECT_OTHER_ASSUMPTIONS_LIMITATIONS,
        featureName: 'Other Assumptions/Limitations',
      },
    ];

    return validateFeatures(validations, isFeatureEnabled);
  }

  onSave(defalutMaterialProjectList: any) {
    this.submitted = true;
    if (!this.showEdit) return;
    if (
      !this.allProjectForm.valid ||
      (this.isShowTeamList && !this.allProjectForm.controls['team'].value) ||
      (this.showSectorDropdown && !this.allProjectForm.controls['sectorBasedDropdown'].value)
    ) {
      this.stopRouting = true;
      return;
    }
    const countriesId = this.allProjectForm.controls['country'].value?.map((x: any) => {
      return x.id;
    });
    const convertedArray = defalutMaterialProjectList.map((k: any) => ({
      materialId: k.materialId,
      range: k.range,
      recycledCreditId: k.recycledCreditId,
    }));
    this.stopRouting = false;
    const payload = {
      packageAccountedProductId: this.scopePresetId,
      projectId: this.allProjectDetails.projectId,
      projectName: this.allProjectForm.controls['projectName'].value,
      shortProjectName: this.allProjectForm.controls['projectNameForReport'].value,
      packagingLCStages: this.payloadPackagingLCStages,
      productLCStages: this.payloadProductLCStages,
      packagingLevels: this.payloadPackagingLevels,
      productWestModeling: this.payloadProductWestModeling,
      shareId: this.allProjectForm.controls['share'].value?.id,
      statusId: this.allProjectForm.controls['status'].value?.id || this.allProjectDetails.statusId,
      organizationId:
        this.allProjectForm.controls['organizationName']?.value?.id ||
        this.allProjectDetails.organizationId,
      countryId:
        this.allProjectForm.controls['defaultCountry'].value?.id ||
        this.allProjectDetails.countryId,
      countryIds: this.allProjectForm.controls['country'].value || countriesId,
      productClassId: this.allProjectForm.controls['productClass'].value?.id,
      productFamilyId: this.allProjectForm.controls['productFamily'].value?.id,
      productDepartmentId: this.allProjectForm.controls['productDepartment'].value?.id,
      teamId: this.allProjectForm.controls['team'].value?.id,
      description: addFullStop(this.allProjectForm.controls['description'].value),
      specificWasteMaterialItems: convertedArray,
      isTurnOffCost: !this.showCurrencyList,
      ProjectFileName: this.selectedFiles,
      ProjectImage: this.fileBase64,
      currencyId: this.selectedCurrency || this.allProjectDetails?.currencyId,
      systemBoundaryJustification: addFullStop(
        this.allProjectForm.controls['boundryJustification'].value
      ),
      ImpectCategoryJustification: addFullStop(
        this.allProjectForm.controls['categoryJustification'].value
      ),
      otherAssumptionsOrLimitation: addFullStop(
        this.allProjectForm.controls['otherLimitations'].value
      ),
      notModal: true,
      isLockProject: this.isLockChecked,
      allocationforRecycling: this.allProjectForm.controls['recycleContent'].value,
      sKUDepartmentId: this.skuDeptId,
      sKUCategoryId: this.skuCatgId,
      sKUSubCategoryId: this.skuSubCatgId,
      sectorsIdentifierId: this.sectorsIdentifierId || this.allProjectDetails?.sectorsIdentifierId,
      recycledCreditId: this.allProjectForm.controls['recycledCredit'].value?.id,
    };
    const missingFeatures = this.validateFeatures(payload);
    if (missingFeatures.length > 0) {
      showFeatureAlert(missingFeatures, this.swalService);
      return;
    }

    this.checkRemoveImgApi = false;
    this.addUpdatePackagingProject(payload);
  }

  async getAllDepartments() {
    const res = await this.organizationReportingService.getAllInternalDataProductCategoriesList();
    if (!res) return;
    this.allDepartments = res?.data?.productDepartmentItems;
    this.allCategoryData = res?.data?.productFamilyItems;
    this.categoryListByDeptId = this.allCategoryData.filter((x: any) => x.parentRefID == 0);
    this.allSubCategoryData = res?.data?.productClassItems;
    this.subCategoryList = this.allSubCategoryData.filter((x: any) => x.parentRefID == 0);
    this.setDefaultData('department');
  }

  async changeDept(event: any) {
    if (event.idLong) {
      this.skuDeptId = event.idLong;
      this.categoryListByDeptId = this.allCategoryData.filter(
        (x: any) => x.parentRefID == event.idLong
      );
      this.subCategoryList = [];
      this.allProjectForm.controls['productFamily'].reset();
      this.allProjectForm.controls['productClass'].reset();
    }
  }

  async getSKUCategory() {
    this.categoryListByDeptId = this.allCategoryData.filter(
      (x: any) => x.parentRefID == this.allProjectDetails.skuDepartmentId
    );
    this.getCategory();
  }

  async getSKUSubCategory() {
    this.subCategoryList = this.allSubCategoryData.filter(
      (x: any) => x.parentRefID == this.allProjectDetails.skuCategoryId
    );
    this.getSubCategory();
  }

  async changeCatg(event: any) {
    if (event.idLong) {
      this.skuCatgId = event.idLong;
      this.subCategoryList = this.allSubCategoryData.filter(
        (x: any) => x.parentRefID == event.idLong
      );
      this.allProjectForm.controls['productClass'].reset();
    }
  }

  changeSubCatg(event: any) {
    if (!event.idLong) return;
    this.skuSubCatgId = event.idLong;
  }

  setDefaultData(type: string) {
    switch (type) {
      case 'department':
        this.skuCatgId = null;
        this.skuDeptId = null;
        this.skuSubCatgId = null;
        this.allProjectForm.controls['productClass'].reset();
        this.allProjectForm.controls['productFamily'].reset();
        this.allProjectForm.controls['productDepartment'].reset();
        this.categoryListByDeptId = this.allCategoryData.filter((x: any) => x.parentRefID == 0);
        this.subCategoryList = this.allSubCategoryData.filter((x: any) => x.parentRefID == 0);
        break;
      case 'category':
        this.skuCatgId = null;
        this.skuSubCatgId = null;
        this.subCategoryList = this.skuDeptId
          ? []
          : this.allSubCategoryData.filter((x: any) => x.parentRefID == 0);
        this.allProjectForm.controls['productClass'].reset();
        this.allProjectForm.controls['productFamily'].reset();
        break;
      case 'subCategory':
        this.skuSubCatgId = null;
        this.subCategoryList =
          !this.skuDeptId && !this.skuCatgId
            ? []
            : this.allSubCategoryData.filter((x: any) => x.parentRefID == 0);
        this.allProjectForm.controls['productClass'].reset();
        break;
      default:
        break;
    }
  }

  downloadExcel() {
    if (this.allProjectDetails?.excelTemplateLink) {
      window.open(this.allProjectDetails.excelTemplateLink);
    }
  }
}
